/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2026
///                                    RXO Inc.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of RXO Inc. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import UploadLanesModal from "../pricing/UploadLanesModal";
import messages from "../../../helpers/messages";
import StrategySelectionModal from "../pricing/StrategySelectionModal";
import { division as divisionTypes, mode } from "../../../helpers/types";
import getModeForUserRole from "../../../helpers/getModeForUserRole";
import SelfPricedEarlyCloseBidActions from "./SelfPricedEarlyCloseBidActions";

export const UploadLanesState = ({
  bidId,
  role,
  division,
  summary,
  user,
  showSelfPricedEarlyCloseBid = false
}) => {
  const { useStrategicCostData } = useSelector(state => state.featureFlags);
  const history = useHistory();
  const route = useLocation().pathname.split("/")[3] || "";

  const [showUploadLanesModal, setShowUploadLanesModal] = useState(false);
  const [showStrategySelectionModal, setShowStrategySelectionModal] =
    useState(false);

  const closeUploadLanesModal = uploaded => {
    setShowUploadLanesModal(false);
    if (uploaded === true) {
      if (route !== "pricing") {
        history.push(`/bid/${bidId}/pricing`);
      }
    }
  };

  const handleImportLanes = () => {
    if (
      division === divisionTypes.coy &&
      userMode === mode.tl &&
      useStrategicCostData
    ) {
      setShowStrategySelectionModal(true);
    } else {
      setShowUploadLanesModal(true);
    }
  };

  const showLaneImportModal = () => {
    setShowStrategySelectionModal(false);
    setShowUploadLanesModal(true);
  };

  const userMode = getModeForUserRole(role);

  return (
    <>
      <p className="inline-block font-size-14 pt-16 mb-0">
        {messages.bidHasBeenAddedToQueueMessage.defaultMessage}
      </p>
      <div className="fr py-8 my-2">
        <button
          className="text-button univers-67-bold-cond font-size-14 uppercase mx-8 h-32"
          data-testid="upload-lanes"
          onClick={handleImportLanes}
        >
          {messages.importLanes.defaultMessage}
        </button>
        {showSelfPricedEarlyCloseBid && summary && user ? (
          <SelfPricedEarlyCloseBidActions summary={summary} user={user} />
        ) : null}
      </div>
      {showUploadLanesModal && (
        <UploadLanesModal
          division={division}
          role={role}
          bidId={bidId}
          handleClose={closeUploadLanesModal}
          fetchAfterUpload={route === "pricing"}
          isLaneImport={true}
          openedFromBanner={true}
        />
      )}
      {showStrategySelectionModal && (
        <StrategySelectionModal
          open={showStrategySelectionModal}
          handleClose={() => setShowStrategySelectionModal(false)}
          showLaneImportModal={showLaneImportModal}
          bidId={bidId}
        />
      )}
    </>
  );
};

export default UploadLanesState;
